<template>
  <v-row justify="center">
    <v-col cols="12">
      <v-hover v-slot:default="{ hover }">
        <v-card style="border-radius: 20px; cursor: pointer;" @click="openDial(data)" transition="fade-transition">
          <v-img
            :aspect-ratio="1/1"
            :src="require('@/assets/pictures/articles/' + data.img)"
          >
            <v-expand-transition>
              <div
                v-if="hover && data.type === 'webdev'"
                class="d-flex transition-fast-in-fast-out green darken-2 v-card--reveal display-3 white--text"
                style="height: 100%;"
              >
                <v-container>
                  <v-row>
                    <v-col cols="12" class="text-h4">
                      {{ data.text.title }}
                    </v-col>
                    <v-col cols="12" class="text-body-1">
                      {{ data.text.description }}
                    </v-col>
                  </v-row>
                </v-container>
              </div>
              <div
                v-if="hover && data.type === 'photography'"
                class="d-flex transition-fast-in-fast-out blue darken-2 v-card--reveal display-3 white--text"
                style="height: 100%;"
              >
                <v-container>
                  <v-row>
                    <v-col cols="12" class="text-h4">
                      {{ data.text.title }}
                    </v-col>
                    <v-col cols="12" class="text-body-1">
                      {{ data.text.description }}
                    </v-col>
                  </v-row>
                </v-container>
              </div>
              <div
                v-if="hover && data.type === 'communication'"
                class="d-flex transition-fast-in-fast-out red darken-2 v-card--reveal display-3 white--text"
                style="height: 100%;"
              >
                <v-container>
                  <v-row>
                    <v-col cols="12" class="text-h4">
                      {{ data.text.title }}
                    </v-col>
                    <v-col cols="12" class="text-body-1">
                      {{ data.text.description }}
                    </v-col>
                  </v-row>
                </v-container>
              </div>
            </v-expand-transition>
          </v-img>
        </v-card>
      </v-hover>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },

  methods: {
    ...mapActions({
      openDial: 'openDial'
    })
  }
}
</script>

<style>
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: .9;
  position: absolute;
  width: 100%;
}
</style>